// extracted by mini-css-extract-plugin
export var aniSpin = "G_d";
export var back = "G_Z";
export var bg__inner = "G_br";
export var el = "G_b";
export var front = "G_bq";
export var inner = "G_r";
export var middle = "G_bp";
export var text = "G_bs";